import { ProductCardFilterOptions } from '~/statistics/types/profile-card.types'
import { ProductCardTypes } from '~/redux/apis/user-stats-api'

import { MathTopicsType } from '../types/common.types'

export function mappingProductCardFilterOptionsWithType(selectedFilterOptions: string[]): string[] {
  let filterOptions: string[] = []
  selectedFilterOptions.forEach((option) => {
    if (option === ProductCardFilterOptions.VIDEO_CRASH_COURSES) {
      filterOptions = [...filterOptions, ProductCardTypes.BOOTCAMP]
    } else if (option === ProductCardFilterOptions.MATH_VAULT) {
      filterOptions = [...filterOptions, ProductCardTypes.MATHVAULT]
    } else if (option === ProductCardFilterOptions.MATH_ESSENTIALS) {
      filterOptions = [...filterOptions, ProductCardTypes.MATHESSENTIAL]
    } else if (option === ProductCardFilterOptions.GAMES) {
      filterOptions = [
        ...filterOptions,
        ProductCardTypes.STACKNLOAD,
        ProductCardTypes.TREAURETRAIL,
        ProductCardTypes.WINDSURFER,
        ProductCardTypes.MULT_GAME,
      ]
    } else if (option === ProductCardFilterOptions.CURRICULUM) {
      filterOptions = [...filterOptions, ProductCardTypes.CURRICULUM_VIDEO, ProductCardTypes.CURRICULUM_ARTICLE]
    } else if (option === ProductCardFilterOptions.TESTS) {
      filterOptions = [...filterOptions, ProductCardTypes.TEST_PREP]
    }
  })

  return filterOptions
}

export function getColorClassnameFromIdForEncyclopediaCards(id: string): string {
  const idNo = id.split('.')[3]

  switch (idNo) {
    case '1':
      return 'orchid-dark'
    case '2':
      return 'blue-blueberry'
    case '3':
      return 'blue-medium-slate'
    case '4':
      return 'pink-deep'
    case '5':
      return 'orange-portland'
    case '6':
      return 'orange-fulvous'
    default:
      return ''
  }
}
export function getColorClassnameFromId(id: string): string {
  const topic = id.split('.')[1]

  switch (topic) {
    case MathTopicsType.ALGEBRA:
      return 'blue-blueberry'
    case MathTopicsType.GEOMETRY:
      return 'blue-medium-slate'
    case MathTopicsType.NUMBER_AND_QUANTITIES:
      return 'orchid-dark'
    case MathTopicsType.STATISTICS_AND_PROBABILITY:
      return 'pink-deep'
    case MathTopicsType.FUNCTIONS:
      return 'orange-portland'
    case MathTopicsType.PROOF:
      return 'orange-fulvous'
    default:
      return ''
  }
}
